<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="231514"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          :custom-search-items="customSearchItems"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <!--统计-->
            <el-button :disabled="total <= 0" type="primary" @click="statistics_clickHandler()">{{ $t('SeaExport.Statistics') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="23151400"
            :grid-options="gridOptions"
            :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            :enable-col-resize="true"
            :enable-sorting="true"
            :check-main-record="false"
            :deselect-main-record="false"
            class="ag-theme-balham"
            style="width: 100%;"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="23151400"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery()"
          />
        </div>
      </div>
      <!-- 统计弹窗 -->
      <el-dialog
        v-if="statisticsDialog.visible"
        v-el-drag-dialog
        :visible.sync="statisticsDialog.visible"
        :title="$t('SeaExport.Statistics')"
        :width="$selectByLang('360px', '445px')"
        :close-on-click-modal="false"
      >
        <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
          <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
            <el-input v-model="statisticsDialog.txtSlaves" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
            <el-input v-model="statisticsDialog.txtCount" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
            <el-input v-model="statisticsDialog.txtCustomerCount" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="20＇" class="custom">
            <el-input v-model="statisticsDialog.txt20" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="40＇" class="custom">
            <el-input v-model="statisticsDialog.txt40" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="40HQ＇" class="custom">
            <el-input v-model="statisticsDialog.txt40hq" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="45＇" class="custom">
            <el-input v-model="statisticsDialog.txt45" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="TEU" class="custom">
            <el-input v-model="statisticsDialog.txtTeu" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Weight2')" class="custom">
            <el-input v-model="statisticsDialog.txtWeight" style="width:160px" :disabled="true" />
            <span>KGS</span>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Cubage')" class="custom">
            <el-input v-model="statisticsDialog.txtCubage" style="width:160px" :disabled="true" />
            <span>CBM</span>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargedWeight')" class="custom">
            <el-input v-model="statisticsDialog.txtChargeWeight" style="width:160px" :disabled="true" />
            <span>M/T</span>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="custom">
            <el-input v-model="statisticsDialog.txtdesignationAgentNum" style="width:160px" :disabled="true" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as LayersUtil from '@/class/cargo/model/utils/LayersUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { findMoreJobForSales2HW } from '@/api/booking/job'
import { formatNumberToThousands } from '@/utils'
import { statisticsJobs } from '@/api/seaExport/seaExportJob'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'SalesQuery2Csr',
  components: { searchItem },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      checkJobTypeHasDiff: false, // 是否验证业务类型
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      total: 0,
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        onRowClicked: this.onRowClicked,
        getRowStyle: (params) => {
          const row = params.data
          const colorType = Number(this.$store.state.settings.colorType) === 1
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': LayersUtil.STATE_BLOCKED.colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of LayersUtil.COLOR_STATES) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [ // 显示列
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 150
        }, {
          headerName: 'SOP',
          field: 'sopState',
          colId: 'sopState',
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerChineseName'),
          colId: 'customerId',
          field: 'customerId',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
            // return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerEnglishName'),
          colId: 'englishName',
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('Message.EnglishNameOfHBLConsignee'),
          colId: 'hblConsigneeLine1',
          field: 'hblConsigneeLine1',
          width: 150
        }, {
          headerName: this.$t('Message.EnglishNameOfHBLShipper'),
          colId: 'hblShipperLine1',
          field: 'hblShipperLine1',
          width: 150
        }, {
          headerName: this.$t('SeaExport.FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          valueFormatter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.TransitPort'),
          colId: 'transferPortCode',
          field: 'transferPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'ETD',
          colId: 'ETD',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          valueFormatter: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          valueFormatter: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          valueFormatter: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('Message.AgentNetworkCustomerService'),
          field: 'overseaOp',
          colId: 'overseaOp',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DestinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 150
        }, {
          headerName: 'MB/L NO',
          field: 'mbl',
          colId: 'mbl',
          valueFormatter: (params) => {
            return ColumnUtils.mblLabelFunc(params.value, params.data)
          },
          width: 150
        }, {
          headerName: 'HB/L NO',
          field: 'hblNo',
          colId: 'hblNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_10') : ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          colId: 'incoTerm',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'isShutOut',
          colId: 'isShutOut',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150
        }
      ],
      rowData: [],
      gridApi: null,
      statisticsDialog: { // 统计
        visible: false,
        txtSlaves: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0
      }
    }
  },
  computed: {
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    }
  },
  created() { },
  methods: {
    // 组装查询条件
    getCustomSearchItems() {
      const defaultSearchFields = []
      // 客户英文名称
      const cmpList = getCacheListByKey(TYPE_NAMES.basic_data_Company)
      if (cmpList && cmpList.length > 0) {
        const options = []
        for (const cmp of cmpList) {
          if (!cmp.customer) {
            continue
          }
          options.push({ code: cmp.cmpIdx, chineseName: cmp.englishName, englishName: cmp.englishName })
        }
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 0
        searchField.defaultValue = ''
        searchField.itemLabel = this.$t('CargoMsg.Cargo_CustomerEnglishName')
        searchField.itemName = 'customerIdEnglishName'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.lock = false
        searchField.dataProvider = options
        searchField.defaultSelected = 1
        searchField.selected = 0
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      return defaultSearchFields
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      // 操作公司
      if (!this.filter.conditions) this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('OMS_JOB.OP_OFFICE', this.filter.conditions)) {
        this.filter.conditions.push(new AdvancedSearchOption(null, 'OMS_JOB.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      }
      const requestBody = {
        otherMap: { saleCsr: 'sale' },
        conditions: this.filter.conditions,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      const colorType = Number(this.$store.state.settings.colorType) === 1
      if (colorType) {
        requestBody.requires = ['financeColor']
      }
      findMoreJobForSales2HW(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      // 业务编号
      if (!this.filter.conditions) this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('OMS_JOB.JOB_NO', this.filter.conditions)) {
        this.filter.conditions.push(new AdvancedSearchOption(null, 'OMS_JOB.JOB_NO', this.filter.jobNo).formatObj2Json())
      }
      // 操作公司
      if (!AdvancedSearchOption.hasField('OMS_JOB.OP_OFFICE', this.filter.conditions)) {
        this.filter.conditions.push(new AdvancedSearchOption(null, 'OMS_JOB.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      }
      const requestBody = {
        conditions: this.filter.conditions,
        otherMap: { saleCsr: 'overseaOp' },
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      const colorType = Number(this.$store.state.settings.colorType) === 1
      if (colorType) {
        requestBody.requires = ['financeColor']
      }
      findMoreJobForSales2HW(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      // 核销状态
      this.rowData = res.results.list || []
      this.filter.pageNum = res.results.pageNum
      this.filter.pageSize = res.results.pageSize
      this.total = Number(res.results.total)
      this.gridApi.clearFocusedCell()
    },
    // 选中行数
    readSelectedRows() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      return rows
    },
    // 统计
    statistics_clickHandler() {
      this.statisticsClean()
      const rows = this.readSelectedRows()
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let count = 0
      for (const job of rows) {
        count++
        jobKeys.push(job.key)

        weight += isNaN(job.weightActual) ? 0 : job.weightActual
        cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
        chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
        slavesCount += 1

        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 3)
      this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 3)
      this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 3)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      statisticsJobs({ jobKeys: jobKeys, lob: 'all' }).then(res => this.statisticsJobsResult(res.data))
    },
    // 统计结果
    statisticsJobsResult(res) {
      if (!res) return
      this.statisticsDialog.txt20 = res.b20
      this.statisticsDialog.txt40 = res.b40
      this.statisticsDialog.txt40hq = res.b40h
      this.statisticsDialog.txt45 = res.b45
      this.statisticsDialog.txtTeu = res.teu
      this.statisticsDialog.visible = true
    },
    // 统计完成 清空对象
    statisticsClean() {
      if (!this.statisticsDialog) return
      for (const key in this.statisticsDialog) {
        this.statisticsDialog[key] = ''
      }
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    }
  }
}
</script>

<style lang="scss">
</style>
